import type {
    AppDispatch,
    RootState,
} from '../store'
import {
    TypedUseSelectorHook,
    shallowEqual,
    useDispatch,
    useSelector,
} from 'react-redux'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppSelectorWithShallowEquality: typeof useAppSelector = (selector) => useAppSelector(selector, shallowEqual)

export {useVisibilityObserver} from './visibilityObserver'
export {useUiState} from './state'
